<div class="flex flex-col gap-4 text-center items-center">
	<div *ngIf="primaryText" class="text-2xl font-bold">
		{{ primaryText }}
	</div>
	<div *ngIf="secondaryText">
		<span [innerHTML]="secondaryText | sanitize"></span>
	</div>
	<div class="flex mt-4 flex-1 justify-between w-full">
		<ui-button
			class="mr-4"
			[label]="noLabel"
			[style]="'ghost'"
			size="sm"
			(click)="onNoClick()"
		></ui-button>
		<ui-button
			class="mr-4"
			[label]="yesLabel"
			size="sm"
			(click)="onYesClick()"
		></ui-button>
	</div>
</div>
